import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Post } from 'src/app/shared/models/posts/post';

@Component({
  selector: 'app-task-memory',
  templateUrl: './task-memory.component.html',
  styleUrls: ['./task-memory.component.scss']
})
export class TaskMemoryComponent implements OnInit {
  @Input() post: Post;
  
  public audioOk: any;
  public showDialogOk: boolean = false;
  public tiles: any;
  private _blockTime = 0;
  private _interval: any;

  constructor(
    private _activatedRoute: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this._activatedRoute.params.subscribe(
      params => {    
        this.closeDialog();
      }
    ); 
    this.tiles = this.post.randomPara();
    this.audioOk = new Audio();
    this.audioOk.src = "./assets/okrzyk.mp3";
  }

  public closeDialog() {
    this.showDialogOk = false;
  }

  public openTile(tile: any) {  
    if (this._canOpen(tile)) {       
      tile.open = true;
      this._checkOpenedTails();
    }
  }

  public showDialog() {
    return this.showDialogOk;
  }

  private _getOpenedTails() {
    let opened = this.tiles.filter(obj => {
      return obj.open === true;
    });
    return opened;
  }

  private _checkOpenedTails() {
    let opened = this._getOpenedTails();
    if (opened.length === 2) {
      if (opened[0].para === opened[1].para) {
        opened[0].para.open = true;
        opened[0].open = false;
        opened[1].open = false;
        this._checkOpenedPary();
      } else {
        this._blockTime = 1;
        this._interval = setInterval(() => { 
          this._reduceBlockTime(); 
        }, 500);
      }
    }
  }

  private _checkOpenedPary() {
    let opened = this.tiles.filter(obj => {
      return obj.para.open === true;
    });
    if (opened.length === this.tiles.length) {
      this.audioOk.play();
      this.showDialogOk = true;
    }    
  }

  private _closeOpenedTails() {
    let opened = this._getOpenedTails();
    opened.forEach(tail => {
      tail.open = false;
    });  
  }

  private _reduceBlockTime() {
    this._blockTime--;
    if (this._blockTime < 0) {
      this._closeOpenedTails();
      clearInterval(this._interval);
    }
  }
  
  public displayTile(tile: any) {
    return (tile.open || tile.para.open)? 'block' : 'none';
  }

  private _canOpen(tile: any) {  
    if (this._blockTime > 0) { return false; }
    if (tile.open) { return false; }
    if (tile.para.open) { return false; }    
    return true;
  }
}
